/* @flow */

const DIRECAO_ASC = 'ASC';
const DIRECAO_DESC = 'DESC';

const ordenar = (ordenacao: string) => {
    const [propriedade, direcao = DIRECAO_ASC] = ordenacao.split(' ');
    const ordem = direcao.toUpperCase() === DIRECAO_DESC ? -1 : 1;
    return (a: Object, b: Object) => (a[propriedade] < b[propriedade] ? 1 : -1) * ordem;
};

export default ordenar;
